import { render, staticRenderFns } from "./shippingAgentSelect.vue?vue&type=template&id=0596d17c"
import script from "./shippingAgentSelect.vue?vue&type=script&lang=js"
export * from "./shippingAgentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports